import * as React from 'react';
import AfrDataCore from '../AfrCore/AfrDataCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';

const AfrDataA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <AfrDataCore userRole={isAdminUser ? "ADMIN" : "USER"} />
        </React.Fragment>
    );
}

export default AfrDataA;